module.exports = __webpack_public_path__ + "img/owl1.02c249dc.png";